/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DemandeValidationDto } from './DemandeValidationDto';
import {
    DemandeValidationDtoFromJSON,
    DemandeValidationDtoFromJSONTyped,
    DemandeValidationDtoToJSON,
    DemandeValidationDtoToJSONTyped,
} from './DemandeValidationDto';
import type { DevisResumeDto } from './DevisResumeDto';
import {
    DevisResumeDtoFromJSON,
    DevisResumeDtoFromJSONTyped,
    DevisResumeDtoToJSON,
    DevisResumeDtoToJSONTyped,
} from './DevisResumeDto';
import type { RetarificationModelDto } from './RetarificationModelDto';
import {
    RetarificationModelDtoFromJSON,
    RetarificationModelDtoFromJSONTyped,
    RetarificationModelDtoToJSON,
    RetarificationModelDtoToJSONTyped,
} from './RetarificationModelDto';

/**
 * A validation request as shown to a validator: request, quote summary and re-pricing model.
 * 
 * @export
 * @interface GetDemandeValidationDetailResponse
 */
export interface GetDemandeValidationDetailResponse {
    /**
     * 
     * @type {DemandeValidationDto}
     * @memberof GetDemandeValidationDetailResponse
     */
    demande: DemandeValidationDto;
    /**
     * 
     * @type {DevisResumeDto}
     * @memberof GetDemandeValidationDetailResponse
     */
    devis: DevisResumeDto;
    /**
     * 
     * @type {RetarificationModelDto}
     * @memberof GetDemandeValidationDetailResponse
     */
    retarification: RetarificationModelDto;
    /**
     * The request is pending and addressed to the current user.
     * @type {boolean}
     * @memberof GetDemandeValidationDetailResponse
     */
    peutRepondre: boolean;
    /**
     * Name of the validator who answered, null while pending.
     * @type {string}
     * @memberof GetDemandeValidationDetailResponse
     */
    traiteePar?: string | null;
}

/**
 * Check if a given object implements the GetDemandeValidationDetailResponse interface.
 */
export function instanceOfGetDemandeValidationDetailResponse(value: object): value is GetDemandeValidationDetailResponse {
    if (!('demande' in value) || value['demande'] === undefined) return false;
    if (!('devis' in value) || value['devis'] === undefined) return false;
    if (!('retarification' in value) || value['retarification'] === undefined) return false;
    if (!('peutRepondre' in value) || value['peutRepondre'] === undefined) return false;
    return true;
}

export function GetDemandeValidationDetailResponseFromJSON(json: any): GetDemandeValidationDetailResponse {
    return GetDemandeValidationDetailResponseFromJSONTyped(json, false);
}

export function GetDemandeValidationDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDemandeValidationDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'demande': DemandeValidationDtoFromJSON(json['demande']),
        'devis': DevisResumeDtoFromJSON(json['devis']),
        'retarification': RetarificationModelDtoFromJSON(json['retarification']),
        'peutRepondre': json['peutRepondre'],
        'traiteePar': json['traiteePar'] == null ? undefined : json['traiteePar'],
    };
}

export function GetDemandeValidationDetailResponseToJSON(json: any): GetDemandeValidationDetailResponse {
    return GetDemandeValidationDetailResponseToJSONTyped(json, false);
}

export function GetDemandeValidationDetailResponseToJSONTyped(value?: GetDemandeValidationDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'demande': DemandeValidationDtoToJSON(value['demande']),
        'devis': DevisResumeDtoToJSON(value['devis']),
        'retarification': RetarificationModelDtoToJSON(value['retarification']),
        'peutRepondre': value['peutRepondre'],
        'traiteePar': value['traiteePar'],
    };
}

